import {NgModule} from '@angular/core';
import {MdPseudoCheckbox} from './pseudo-checkbox/pseudo-checkbox';


@NgModule({
  exports: [MdPseudoCheckbox],
  declarations: [MdPseudoCheckbox]
})
export class MdSelectionModule { }


export * from './pseudo-checkbox/pseudo-checkbox';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/_core.md2/selection/index.ts